import React from 'react'
import PropTypes from "prop-types"
import { omit, values } from 'lodash'
import Button from '../../components/Button'
import { randstr } from '../../../lib/Tools'
import Menu from './Menu'

import "./Carta.less"

const emptyMenu = {
  id : "",
  name : "",
  chName : "",
  description : "",
  drinksDescription : "",
  price : 0,
  includesMeat : null,
  includesFish : null,
  isVegan : null,
  background : {
    image : null
  },
  dishes : {},
  drinks : {},
}

const MenusList = ({ menus, onChange }) => (    
  <div>
    {
      values(menus).map(menu => (
        <Menu
          key={menu.id}
          menu={menu}
          onChange={change => onChange({ menus:{ ...menus, [menu.id]: { ...menus[menu.id], ...change } } })}
          onRemove={() => onChange({ menus: omit(menus, menu.id) })}
        />
      ))
    }
    <Button
      glyph="plus"
      onClick={() => {
        const id = randstr(12)
        onChange({ menus: { ...menus, [id]: { ...emptyMenu, id } } })
      }}
    >
        Añadir menu
    </Button>
  </div>
)

MenusList.propTypes = {
  onChange: PropTypes.func.isRequired,
  menus: PropTypes.object.isRequired,
}

export default MenusList